<script lang="ts">
	export let listClass = '';
	export let itemClass = '';
	export let listElClass: string | undefined = undefined;
	export let preserveListType = true;
	export let as: keyof HTMLElementTagNameMap = 'div';
	export let ariaLabel: string | undefined = undefined;

	$: computedListElClass = listElClass ?? (listClass ? `${listClass}__list` : '');
</script>

<svelte:element
	this={as}
	class={listClass}
	data-cardlist-scope="true"
	data-cardlist-item-class={itemClass}
	data-cardlist-list-class={computedListElClass}
	data-cardlist-preserve-type={preserveListType}
	aria-label={ariaLabel}
>
	<slot />
</svelte:element>

<style>
	/* Fallback CSS for when plugin isn't configured */
	:global([data-cardlist-scope] > :is(ul, ol)) {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	:global([data-cardlist-scope] > :is(ul, ol) > li) {
		margin: 0.5rem 0;
		padding: 0.75rem;
		border: 1px solid rgba(0, 0, 0, 0.1);
		border-radius: 0.375rem;
		background: rgba(255, 255, 255, 0.8);
		backdrop-filter: blur(4px);
	}
</style>
